import {
  buildRoomsMapLayer,
  HaNContext,
  HaNMapStageContext,
  useFacilityMarkers,
  useHaNMapLayer,
  useRoomsRequest,
} from "@lib/logic";
import { getMeetingRoomRequestState, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

export const RoomsMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "rooms" || !floorId) return null;

  return <RoomsMapLayer floorId={floorId} />;
};

// Builds the tab's layer for the page's one map, which the map stage draws
const RoomsMapLayer = ({ floorId }: { floorId: string }) => {
  const { building, filterData } = useRequiredContext(HaNContext);
  const request = useRoomsRequest();
  const suggestions = useAppSelector(state => getMeetingRoomRequestState(state, request)?.meetingRoomSuggestion);
  const facilityMarkers = useFacilityMarkers(building.buildingId ?? "", floorId);

  const layer = buildRoomsMapLayer({ floorId, rooms: filterData.rooms.filteredData, suggestions, facilityMarkers });

  useHaNMapLayer(layer);

  return null;
};
